<script>
		import {user, view, send_request} from "../client.svelte.js";
		import {perksToString} from "../core.js";
		import Select from "../elements/Select.svelte";
		import GearSheet from "../manage/GearSheet.svelte";
		import MasterTradePanel from "../panels/MasterTradePanel.svelte";

		const heroes = game.heroes.map(persID => game.personas.get(persID))

		let obtainables = $derived(
      ((user.isMaster) ? view.adventure.rewards : game.obtainables)
        .map(itemID => user.gearitems.get(itemID))
        .map(item => Object.assign({}, item, {holder: user.possessions.values().find(poss => poss.ITEM === item.ID && poss.gained !== null)?.CHAR ?? null}))
        // .sort((a,b) => a.name.localeCompare(b.name))
		)

		let grpItems = $derived(Object.groupBy(obtainables, (item) => item.type ?? "Sonstige") )

		// $inspect(`REWARDS - grpItems`, grpItems)

		function edit_item() {
        const mode = (user.isMaster) ? 'chg' : 'view'
				view.show_dialog('gearitem', {item: this, mode: mode})
		}

		function show_item(e) {
        console.log(`${e.target.checked}  show_item`, $state.snapshot(this))
        send_request('control', {command: 'OBTAIN', item: this.ID, obtainable: e.target.checked})
		}

		function obtain_item(e) {
        const charID = e.target.value
        console.log(`${charID} obtain_item`, $state.snapshot(this))
        send_request('control', {command: 'OBTAIN', item: this.ID, obtainer: charID})
		}

</script>


<!-------------------------------- HTML -------------------------------------->

<div class=obtain>

  <div class="obtainables">
		<h2>{(user.isMaster) ? "Findbare Gegenstände" : "Gefundene Gegenstände"}</h2>
		<br>
		<div class="items">
      <b>Vis</b>
      <b>Gegenstand</b>
      <b>Aussehen</b>
      <b>Stufe</b>
      <b>Besonderheiten</b>
      <b>Gew.</b>
      <b>Besitzer</b>
      {#each obtainables as item}
        {@render itemrow(item)}
      {/each}
		</div>
  </div>

	{#snippet itemrow(item)}
		{#if user.isMaster}
      <input id={item.ID} data-help="visible" type="checkbox" checked={game.obtainables.includes(item.ID)} onchange={show_item.bind(item)}>
		{:else}
      <span></span>
		{/if}
		<span onclick={edit_item.bind(item)}>{item.name}</span>
		<span onclick={edit_item.bind(item)}>{item.descript}</span>
		<span onclick={edit_item.bind(item)}>{item.grade}</span>
		<span onclick={edit_item.bind(item)}>{item.specials}</span>
		<span onclick={edit_item.bind(item)}>{item.weight}</span>
		<Select field={item.ID} help="holder" value={item.holder} options={heroes} unlabeled disabled={!user.isMaster} onchange={obtain_item.bind(item)}/>
  {/snippet}

</div>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.obtain
		height: 100vh
		display: grid
		grid-template-rows: auto 1fr

	.gear
		overflow-y: auto
		scrollbar-width: none
		&::-webkit-scrollbar
			display: none

	.obtainables
		padding: 12px
		background-color: colors.$grey-20
	
	.grade
		text-align: center

	.weight
		width: 8ch

	.greyed
		color: grey

	.rightAlign
		padding: 0 8px
		text-align: right

	.items
		width: 95%
		display: grid
		grid-template-columns: 3ch 1fr 3fr 4ch 2fr 6ch 10ch
		grid-gap: 8px
		align-items: center

	input[type='checkbox']
		width: 24px

</style>